import { useInkind } from '@gik/api/inkinds/inkind';
import bemBlock from '@gik/core/utils/bemBlock';
import { InkindPageContent, InkindPageViewRecorder, SamplePageBanner } from '@gik/inkind-page';
import React from 'react';
import { useSearchParam } from 'react-use';
import { RelatedProductsSection } from '@gik/product-page';
import { useSimilarProducts } from '@gik/api/products/products';
import InkindPageTour, { inkindPageTourSelectors } from '@gik/inkind-page/components/InkindPageTour/InkindPageTour';
import InkindPageHeader from '../InkindPageHeader/InkindPageHeader';
import useFinishRegistration from '@gik/finish-registration/hooks/useFinishRegistration';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import { canUserEditPage } from '@gik/inkind-page/utils/inkindPagePermissions';
import { useUserStore } from '@gik/core/store/UserStore';
import { useInkindStore } from '@gik/inkind/store/InkindStore';
import { useGIKTitle } from '@gik/core/hooks/hooks/useGIKTitle';

export interface InkindPageProps {
  inkindRouteId: string; // TODO rename to routeId
  overrideIsSamplePage?: boolean;
}

export default function InkindPage({ inkindRouteId: routeId, overrideIsSamplePage }: InkindPageProps) {
  //  TODO: (and we need to standardize the use of `routeId` vs other `inkindRouteId` etc..)
  //  TODO: stop prop-drilling the inkind route ID, use the inkind store

  const setInkindRouteId = useInkindStore(store => store.setInkindRouteId);
  setInkindRouteId(routeId);
  const bem = bemBlock('inkind-page');
  const { t } = useTranslation();
  const { data: inkindPage } = useInkind(routeId);
  // TODO: pass taxonomies and relation IDs into RelatedProductsSection
  const { data: similarProducts } = useSimilarProducts(inkindPage?.inkindSituations?.map(situation => situation.id));
  const isSamplePageParamValue = useSearchParam('sample-page');
  const isSamplePage = isSamplePageParamValue === 'true' || overrideIsSamplePage;
  const userId = useUserStore(state => state.id);
  const canEdit = canUserEditPage(inkindPage, userId);
  const showSuggestedItemsDisableButton = canEdit && !inkindPage.isPremium;

  useFinishRegistration(routeId);

  const titleEL = useGIKTitle(inkindPage?.title);

  return (
    <div className={bem()}>
      {titleEL}
      {isSamplePage && <SamplePageBanner />}
      {/* TODO: review selectors */}
      <InkindPageTour selectors={inkindPageTourSelectors} inkindRouteId={routeId} />
      <InkindPageViewRecorder inkindRouteId={routeId} />
      <InkindPageHeader inkindRouteId={routeId} />
      <InkindPageContent inkindRouteId={routeId} showSuggestedItemsDisableButton={showSuggestedItemsDisableButton} />
      {(inkindPage ? inkindPage.enableSuggestedProducts : true) && (
        <RelatedProductsSection
          className={bem('related-products')}
          copy={t(translationKeys.RelatedProductsCopy)}
          variant={'solid-neutral-100'}
          products={similarProducts}
          showSuggestedItemsDisableButton={showSuggestedItemsDisableButton}
        />
      )}
    </div>
  );
}
